import * as React from "react";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CardHeader from "@mui/material/CardHeader";
import CardActionArea from "@mui/material/CardActionArea";
import ArrowDropDownRounded from "@mui/icons-material/ArrowDropDownRounded";

import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { signOut } from "toolkits/redux/auth";
import Update from "./Update";

export default function BasicPopover() {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {
    userInfo: { firstname, lastname, cellphone, roles },
  } = useSelector((state) => state.auth);

  const onOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const logout = async () => {
    try {
      dispatch(signOut());
      onClose();
    } catch (error) {}
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Card sx={{ bgcolor: "transparent" }}>
        <CardActionArea aria-describedby={id} onClick={onOpen}>
          <Stack
            p={1}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Avatar
              sx={{
                bgcolor: "transparent",
                display: { xs: "none", sm: "unset" },
              }}
            >
              <ArrowDropDownRounded fontSize="small" color="action" />
            </Avatar>
            <Typography
              px={1}
              variant="subtitle1"
              display={{ xs: "none", sm: "unset" }}
            >{`${firstname} ${lastname}`}</Typography>
            <Stack alignItems="center">
              <Avatar />
              <Typography
                mt={-0.5}
                zIndex={1}
                fontSize={9}
                borderRadius={2}
                px={0.5}
                color="#fff"
                variant="caption"
                bgcolor="secondary.main"
              >
                {roles[0]?.title || "کاربر عادی"}
              </Typography>
            </Stack>
          </Stack>
          {/* <CardHeader
            sx={{ p: 1 }}
            title={
              <Typography
                px={1}
                variant="subtitle1"
                display={{ xs: "none", sm: "flex" }}
              >{`${firstname} ${lastname}`}</Typography>
            }
            action={
              <Stack alignItems="center">
                <Avatar />
                <Typography
                  mt={-0.5}
                  zIndex={1}
                  fontSize={9}
                  borderRadius={2}
                  px={0.5}
                  color="#fff"
                  variant="caption"
                  bgcolor="secondary.main"
                >
                  {roles[0]?.title || "کاربر عادی"}
                </Typography>
              </Stack>
            }
            avatar={
              <Avatar sx={{ bgcolor: "transparent", display: {xs: 'none', sm: 'flex'} }}>
                <ArrowDropDownRounded fontSize="small" color="action" />
              </Avatar>
            }
          /> */}
        </CardActionArea>
      </Card>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Stack width={260} p={2} rowGap={1} alignItems="center">
          {roles.map((role) => (
            <Typography
              px={2}
              py={0.5}
              key={role.id}
              fontSize={12}
              borderRadius={3}
              lineHeight={1.5}
              color="error.dark"
              variant="subtitle2"
              bgcolor="error.lighter"
            >
              {role.title}
            </Typography>
          ))}
          <Typography variant="subtitle2">{cellphone}</Typography>
          <Stack width="100%" direction="row" columnGap={1}>
            <Button
              fullWidth
              color="error"
              onClick={logout}
              sx={{ bgcolor: "action.hover" }}
            >
              خروج
            </Button>
            <Update />
          </Stack>
        </Stack>
      </Popover>
    </div>
  );
}
